import { Banner } from "@src/appV2/redesign/system/ui-components";

export function FileUploaderLimitReached() {
  return (
    <Banner
      intent="warning"
      illustrationType="document-rejected"
      title="Can't upload more files"
      description="You have reached the maximum number of files you can upload. Please remove some files before uploading more."
    />
  );
}
